import { useState } from 'react';

import { useUserWalletQuery } from '@queries/UserQueries';

import { useAnalytics } from '@hooks/useAnalytics';

import { sanitizeVenmoUsername } from '@utilities/sanitizeVenmoHandle';

import Button from '@components/buttons/Button';
import { Input } from '@components/form/Input';
import Card from '@components/layout/Card/Card';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { useUpdateEntertainerMutation } from '@mutations/EntertainerMutations';

export const VenmoCard = ({ entertainer }) => {
  const { track } = useAnalytics();
  const { wallet } = useUserWalletQuery();
  const [venmoHandle, setVenmoHandle] = useState(entertainer.contact?.venmo);
  const { isSubmitting, updateEntertainerAsync } = useUpdateEntertainerMutation();
  const [didSubmit, setDidSubmit] = useState(false);

  if (entertainer.contact?.venmo) {
    return <></>;
  }

  const handleSubmit = async () => {
    track('Add Venmo Click', { venmoHandle });
    await updateEntertainerAsync({
      contact: {
        ...(entertainer.contact ?? {}),
        venmo: sanitizeVenmoUsername(venmoHandle),
      },
    });
    setDidSubmit(true);
  };

  return (
    <Card className="mt-2">
      <Card.Body>
        <TitleToolbar
          size="sm"
          text="Add Venmo"
          action={
            Boolean(wallet?.total) && (
              <div>
                <strong>{`Wallet balance: `}</strong>
                <span>{`$${(wallet?.total / 100).toFixed(2)}`}</span>
              </div>
            )
          }
        />
        <p>To accept tips on your "werqwith.me" page, add your Venmo handle to your profile.</p>
        <Input
          variant="outlined"
          placeholder="eg. your.venmo.handle"
          onChange={(e) => setVenmoHandle(e.target.value)}
        />
      </Card.Body>
      <Card.Footer>
        <Button disabled={isSubmitting || didSubmit} onClick={handleSubmit}>
          {didSubmit ? 'Venmo Added!' : 'Add Venmo'}
        </Button>
      </Card.Footer>
    </Card>
  );
};
